module.exports = __webpack_public_path__ + "static/media/universe.bf86c594.svg";